import { logout, getUserInfo } from '@/api/auth'
import { getUserBridges, getAllBridges, getBridgeById } from '@/api/bridge'
import VideoUrlManager from '@/utils/videoUrlManager'
import { checkAndShowPermissionError } from '@/utils/permissionUtils'
import signalRIdentityManager from '@/utils/signalr-identity-manager'

export default {
  name: 'AppLayout',
  data() {
    return {
      isCollapsed: false,
      activeMenu: null,
      submenuTop: 0,
      submenuLeft: 0,
      hideSubmenuTimer: null,
      username: '用户',
      roles: [],
      // 桥梁选择相关
      bridgeOptions: [], // 改为空数组，将从API加载
      bridgeLoading: false,
      selectedBridge: null,
      selectedBridgeId: '',
      submenuHovered: false,
      // 多桥梁选择相关
      selectedBridges: [], // 选中的桥梁对象列表
      selectedBridgeIds: [] // 选中的桥梁ID列表
    }
  },
  created() {
    // 检查是否已登录
    this.checkAuth();
    
    // 获取用户信息
    this.fetchUserInfo();
    
    // 加载当前账号的桥梁数据
    this.loadBridges();
    
    // 检查URL中的权限错误提示
    this.checkPermissionError();
    
    // // 加载保存的桥梁选择
    // this.loadSavedBridge();
  },
  computed: {
    // 计算子菜单样式
    getSubmenuStyle() {
      return () => {
        return {
          top: this.submenuTop + 'px',
          left: this.submenuLeft + 'px',
          width: '280px' // 显式设置宽度
        }
      }
    }
  },
  watch: {
    $route: {
      handler() {
        // 当访问页面时自动关闭菜单
        this.activeMenu = null;
      },
      immediate: true
    },
    selectedBridgeId(newId) {
      // 当ID改变时，更新selectedBridge对象
      if (newId) {
        const bridge = this.bridgeOptions.find(b => b.id === newId);
        if (bridge) {
          this.selectedBridge = bridge;
        }
      }
    },
    selectedBridge: {
      handler(newBridge) {
        if (newBridge) {
          // 先存储选中的桥梁到本地存储
          localStorage.setItem('selectedBridge', JSON.stringify(newBridge));
          
          console.log(`选择桥梁: ${newBridge.name}, ID: ${newBridge.id}, 位置: [${newBridge.latitude}, ${newBridge.longitude}]`);
          
          // 触发自定义事件，通知子组件桥梁已更改
          this.$root.$emit('bridge-changed', newBridge);
        }
      },
      deep: true
    }
  },
  methods: {
    checkAuth() {
      // 检查是否有token，如果没有则跳转到登录页
      const token = localStorage.getItem('token');
      if (!token) {
        this.$router.push('/login');
      }
    },
    
    // 检查URL中的权限错误提示
    checkPermissionError() {
      checkAndShowPermissionError(this.$route, this.$router, this.$message);
    },
    async fetchUserInfo() {
      try {
        // 从localStorage获取用户名，如果存在则显示
        const storedUsername = localStorage.getItem('username')
        if (storedUsername) {
          this.username = storedUsername
        }
        
        // 获取token
        const token = localStorage.getItem('token')
        if (token) {
          // 从API获取用户信息
          const response = await getUserInfo()
          if (response.code === 200 && response.data) {
            // 更新用户名和角色信息
            this.username = response.data.username || '用户'
            this.roles = response.data.roles || []
            this.userId = response.data.userId || ''
            
            // 更新本地存储
            localStorage.setItem('username', this.username)
            localStorage.setItem('userId', this.userId)
            
            // 保存权限信息到localStorage，供其他组件使用
            if (this.roles && this.roles.length > 0) {
              const isAdmin = this.roles.some(role => role === 'ADMIN');
              const isMonitor = this.roles.some(role => role === 'MONITOR');
              const hasAdminAccess = isAdmin || isMonitor; // ADMIN或MONITOR权限都可以访问后台管理
              
              localStorage.setItem('isAdmin', isAdmin);
              localStorage.setItem('isMonitor', isMonitor);
              localStorage.setItem('hasAdminAccess', hasAdminAccess);
              localStorage.setItem('userRoles', JSON.stringify(this.roles));
              
              // 触发权限更新事件，通知其他组件权限已更新
              this.$root.$emit('permissions-updated');
            }
          }
        }
      } catch (error) {
        console.error('获取用户信息失败', error)
      }
    },
    async handleLogout() {
      this.$confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          // 使用身份管理器处理退出
          // await signalRIdentityManager.handleLogout(this.$signalR)
          
          // 不管API调用结果如何，都确保清除本地存储的用户信息和token
          localStorage.removeItem('username')
          localStorage.removeItem('token')
          localStorage.removeItem('userId')
          
          try {
            const response = await logout()
            if (response.code === 200) {
              this.$message({
                type: 'success',
                message: '退出登录成功'
              })
            }
          } catch (error) {
            console.error('退出登录API调用失败', error)
            // 不显示错误消息，静默处理API调用失败
          }
          
          // 无论如何都跳转到登录页
          this.$router.push('/login')
        } catch (error) {
          console.error('退出处理过程出错', error)
          // 确保即使发生错误，也清除令牌并重定向
          localStorage.removeItem('username')
          localStorage.removeItem('token')
          localStorage.removeItem('userId')
          localStorage.removeItem('signalrClientInfo')
          this.$router.push('/login')
        }
      }).catch(() => {})
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      localStorage.setItem('sidebarCollapsed', this.isCollapsed);
    },
    onMenuEnter(menu) {
      this.activeMenu = menu;
    },
    onMenuLeave() {
      setTimeout(() => {
        if (!this.submenuHovered) {
          this.activeMenu = null;
        }
      }, 50);
    },
    onSubmenuEnter(menu) {
      this.submenuHovered = true;
      this.activeMenu = menu;
    },
    onSubmenuLeave() {
      this.submenuHovered = false;
      setTimeout(() => {
        if (!this.submenuHovered) {
          this.activeMenu = null;
        }
      }, 50);
    },
    hideAllSubmenus() {
      this.activeMenu = null;
    },
    checkForCoordinatesPanel() {
      // 查找可能的经纬度面板元素
      // 通常经纬度面板可能是位于顶部或右上角的固定元素
      const possiblePanels = document.querySelectorAll('.coordinate-panel, .map-coordinates, .geolocation-panel');
      
      if (possiblePanels && possiblePanels.length > 0) {
        // 找到了类似经纬度面板的元素，调整子菜单样式
        document.querySelectorAll('.submenu-fixed').forEach(submenu => {
          // 确保子菜单始终位于最上层
          submenu.style.zIndex = '9999';
        });
      }
    },
    // 加载桥梁数据
    async loadBridges() {
      this.bridgeLoading = true;
      
      try {
        // 获取当前登录用户信息
        const userInfo = await getUserInfo();
        console.log('userInfo:', userInfo);
        if (userInfo && userInfo.code === 200 && userInfo.data && userInfo.data.userId) {
          const userId = userInfo.data.userId;
          const roles = userInfo.data.roles || [];
          console.log('userId:', userId, 'roles:', roles);
          
          // 优化权限判断逻辑：保存完整的权限信息到localStorage
          const isAdmin = roles.some(role => role === 'ADMIN');
          const isMonitor = roles.some(role => role === 'MONITOR');
          const hasAdminAccess = isAdmin || isMonitor; // ADMIN或MONITOR权限都可以访问后台管理
          
          // 保存权限信息到localStorage，供其他组件使用
          localStorage.setItem('isAdmin', isAdmin);
          localStorage.setItem('isMonitor', isMonitor);
          localStorage.setItem('hasAdminAccess', hasAdminAccess);
          localStorage.setItem('userRoles', JSON.stringify(roles));
          
          // 触发权限更新事件，通知其他组件权限已更新
          this.$root.$emit('permissions-updated');
          
          let response;
          // 根据角色判断：管理员获取所有桥梁，普通用户获取关联桥梁
          if (isAdmin) {
            // 管理员获取所有桥梁
            response = await getAllBridges();
          } else {
            // 普通用户获取关联桥梁
            response = await getUserBridges(userId);
          }
          
          if (response && response.code === 200 && response.data) {
            // 转换API返回的数据格式，保留完整的位置信息
            let bridges = response.data.map(bridge => ({
              id: bridge.bridgeId || bridge.id.toString(),
              name: bridge.bridgeName || bridge.name || '未命名桥梁',
              // 保留原始经纬度位置信息
              longitude: bridge.longitude,
              latitude: bridge.latitude,
              // 保留其他可能有用的字段
              bridgeCode: bridge.bridgeCode,
              roleType: bridge.roleType,
              height: bridge.height,
              bridgeType: bridge.bridgeType,
              // 存储原始数据对象
              originalData: bridge
            }));
            
            // 对桥梁数据进行倒序排列
            bridges = bridges.reverse();
            
            this.bridgeOptions = bridges;
            
            console.log('成功加载用户关联的桥梁列表:', this.bridgeOptions.length);
            
            if (this.bridgeOptions.length > 0) {
              this.initializeBridgeSelection();
            } else {
              this.$message.warning('您没有关联任何桥梁，请联系管理员分配权限');
            }
          } else {
            console.error('加载用户关联桥梁列表失败:', response);
            this.$message.error('获取关联桥梁失败：' + (response?.message || '浏览器网络有波动，请稍后再试'));
            this.bridgeOptions = [];
          }
        } else {
          console.error('获取当前用户信息失败，无法获取关联桥梁');
          this.$message.error('获取用户信息失败，请重新登录');
          this.bridgeOptions = [];
        }
      } catch (error) {
        console.error('加载用户关联桥梁列表出错:', error);
        this.$message.error('获取关联桥梁失败：' + (error?.message || '网络错误'));
        this.bridgeOptions = [];
      } finally {
        this.bridgeLoading = false;
      }
    },
    
    /**
     * 初始化桥梁选择状态
     */
    initializeBridgeSelection() {
      // 首先尝试恢复多桥梁选择状态
      const multiBridgeRestored = this.loadMultiBridgeSelection()
      
      if (multiBridgeRestored) {
        // 成功恢复多桥梁状态，发送事件通知组件更新
        console.log('【Layout】成功恢复多桥梁选择状态，通知组件更新')
        
        // 发送桥梁变更事件
        this.$root.$emit('bridge-changed', this.selectedBridge)
        
        // 发送多桥梁选择变更事件
        const eventData = {
          selectedBridges: this.selectedBridges,
          selectedBridgeIds: this.selectedBridgeIds,
          primaryBridge: this.selectedBridge
        }
        this.$root.$emit('bridges-selection-changed', eventData)
        
        return // 恢复成功，直接返回
      }
      
      // 如果多桥梁状态恢复失败，则使用传统的单桥梁恢复逻辑
      console.log('【Layout】多桥梁状态恢复失败，使用单桥梁恢复逻辑')
      
      // 检查当前选中的桥梁ID是否在新加载的桥梁列表中
      // 再次从localStorage中获取selectedBridge
      const selectedBridge = localStorage.getItem('selectedBridge');
      if (selectedBridge) {
        try {
          const selectedBridgeData = JSON.parse(selectedBridge);
          this.selectedBridgeId = selectedBridgeData.id;
        } catch (error) {
          console.error('【Layout】解析选中桥梁数据失败:', error);
        }
      }

      const isBridgeInList = this.bridgeOptions.some(bridge => bridge.id === this.selectedBridgeId);
      
      // 如果当前选中的桥梁不在列表中，或者没有选中的桥梁，则选择第一个
      if (!isBridgeInList && this.bridgeOptions.length > 0) {
        console.log('【Layout】当前选中的桥梁不在列表中或未选中桥梁，选择第一个桥梁');
        this.selectedBridge = this.bridgeOptions[0];
        this.selectedBridgeId = this.bridgeOptions[0].id;
        
        // 初始化多桥梁状态为单桥梁
        this.selectedBridges = [this.selectedBridge]
        this.selectedBridgeIds = [this.selectedBridge.id.toString()]
        
        // 保存选择到localStorage
        localStorage.setItem('selectedBridge', JSON.stringify(this.selectedBridge));
        this.saveMultiBridgeSelection()
        
        // 发送桥梁变更事件
        this.$root.$emit('bridge-changed', this.selectedBridge);

        // 刷新SignalR身份（确保刷新后携带当前桥梁ID）
        this.updateSignalRIdentityWithBridge(this.selectedBridge);
      } else if (isBridgeInList) {
        // 如果选中的桥梁在列表中，更新selectedBridge对象
        const bridge = this.bridgeOptions.find(b => b.id === this.selectedBridgeId);
        if (bridge) {
          this.selectedBridge = bridge;
          
          // 初始化多桥梁状态为单桥梁
          this.selectedBridges = [bridge]
          this.selectedBridgeIds = [bridge.id.toString()]
          this.saveMultiBridgeSelection()
          
          // 发送桥梁变更事件
          this.$root.$emit('bridge-changed', this.selectedBridge);

          // 刷新SignalR身份（确保刷新后携带当前桥梁ID）
          this.updateSignalRIdentityWithBridge(bridge);
        }
      }
    },
    
    /**
     * 保存多桥梁选择状态到localStorage
     */
    saveMultiBridgeSelection() {
      try {
        const multiBridgeState = {
          selectedBridges: this.selectedBridges,
          selectedBridgeIds: this.selectedBridgeIds,
          timestamp: Date.now()
        }
        localStorage.setItem('multiBridgeSelection', JSON.stringify(multiBridgeState))
        console.log('【Layout】已保存多桥梁选择状态:', multiBridgeState)
      } catch (error) {
        console.error('【Layout】保存多桥梁选择状态失败:', error)
      }
    },
    
    /**
     * 从localStorage恢复多桥梁选择状态
     */
    loadMultiBridgeSelection() {
      try {
        const savedState = localStorage.getItem('multiBridgeSelection')
        if (savedState) {
          const multiBridgeState = JSON.parse(savedState)
          
          // 验证数据有效性
          if (multiBridgeState.selectedBridges && Array.isArray(multiBridgeState.selectedBridges) &&
              multiBridgeState.selectedBridgeIds && Array.isArray(multiBridgeState.selectedBridgeIds)) {
            
            // 过滤出仍然存在的桥梁
            const validBridges = multiBridgeState.selectedBridges.filter(bridge => 
              this.bridgeOptions.some(option => option.id.toString() === bridge.id.toString())
            )
            
            const validBridgeIds = validBridges.map(bridge => bridge.id.toString())
            
            if (validBridges.length > 0) {
              this.selectedBridges = validBridges
              this.selectedBridgeIds = validBridgeIds
              
              // 设置主桥梁
              this.selectedBridge = validBridges[0]
              this.selectedBridgeId = validBridges[0].id
              
              console.log('【Layout】已恢复多桥梁选择状态:', {
                selectedBridges: validBridges.length,
                bridgeNames: validBridges.map(b => b.name)
              })
              
              return true
            }
          }
        }
      } catch (error) {
        console.error('【Layout】恢复多桥梁选择状态失败:', error)
      }
      return false
    },
    
    /**
     * 清除多桥梁选择状态
     */
    clearMultiBridgeSelection() {
      localStorage.removeItem('multiBridgeSelection')
      console.log('【Layout】已清除多桥梁选择状态')
    },
    
    /**
     * 刷新桥梁数据
     */
    async refreshBridgeData() {
      console.log('【Layout】刷新桥梁数据');
      // 重新从服务器加载桥梁数据
      await this.loadBridges();
    },
    
    // 桥梁选择相关方法
    loadSavedBridge() {
      // 从localStorage加载保存的桥梁数据
      try {
        const savedBridge = localStorage.getItem('selectedBridge');
        if (savedBridge) {
          this.selectedBridge = JSON.parse(savedBridge);
          this.selectedBridgeId = this.selectedBridge.id;
          
          // 发送桥梁变更事件
          this.$root.$emit('bridge-changed', this.selectedBridge);
        }
      } catch (error) {
        console.error('加载保存的桥梁数据出错', error);
      }
    },
    handleOutsideClick(event) {
      // 检查点击是否在桥梁选择器之外
      const bridgeSelector = this.$refs.bridgeSelector;
      if (bridgeSelector && !bridgeSelector.contains(event.target)) {
        this.bridgeMenuVisible = false;
      }
    },
    // 新增处理SideNav组件的菜单变化
    onSideNavMenuChanged(menu) {
      this.activeMenu = menu;
    },
    
    // 新增处理SideNav组件的折叠状态变化
    onSideNavCollapseChanged(collapsed) {
      this.isCollapsed = collapsed;
    },
    
    /**
     * 处理桥梁树选择器的选择变更
     */
    async handleBridgeSelectionChange(selectionData) {
      console.log('【Layout】收到桥梁选择变更事件:', selectionData)
      
      // 更新多桥梁选择数据
      this.selectedBridges = selectionData.selectedBridges || []
      this.selectedBridgeIds = selectionData.selectedBridgeIds || []
      
      // 保持selectedBridgeId为第一个选择的桥梁ID（兼容现有代码）
      if (selectionData.selectedBridgeId) {
        this.selectedBridgeId = selectionData.selectedBridgeId
        
        // 更新selectedBridge对象（处理数字/字符串类型不匹配问题）
        const bridge = this.bridgeOptions.find(b => b.id.toString() === selectionData.selectedBridgeId.toString())
        console.log('【Layout】查找桥梁:', {
          targetId: selectionData.selectedBridgeId,
          bridgeOptions: this.bridgeOptions.map(b => ({ id: b.id, name: b.name })),
          foundBridge: bridge
        })
        if (bridge) {
          this.selectedBridge = bridge
          
        // 先存储选中的桥梁到本地存储
        localStorage.setItem('selectedBridge', JSON.stringify(bridge))
        
        // 保存多桥梁选择状态
        this.saveMultiBridgeSelection()
        
        console.log(`主桥梁选择: ${bridge.name}, ID: ${bridge.id}, 位置: [${bridge.latitude}, ${bridge.longitude}]`)
        console.log(`总共选择了 ${this.selectedBridges.length} 个桥梁:`, this.selectedBridges.map(b => b.name))

          // 已有身份重注册方法，切换桥梁时更新本地身份中的桥梁ID并触发身份刷新（同时将桥梁ID写入clientId）
          await this.updateSignalRIdentityWithBridge(bridge);
          
          // 触发自定义事件，通知子组件桥梁已更改
          this.$root.$emit('bridge-changed', bridge)
        } else {
          console.warn('【Layout】未找到匹配的桥梁对象，selectedBridgeId:', selectionData.selectedBridgeId)
        }
        
        // 无论是否找到桥梁，都要触发多桥梁选择事件
        const eventData = {
          selectedBridges: this.selectedBridges,
          selectedBridgeIds: this.selectedBridgeIds,
          primaryBridge: bridge || null
        };
        console.log('【Layout】触发bridges-selection-changed事件:', eventData);
        this.$root.$emit('bridges-selection-changed', eventData)
      } else {
        // 如果没有选中任何桥梁，清空相关数据
        this.selectedBridgeId = ''
        this.selectedBridge = null
        this.selectedBridges = []
        this.selectedBridgeIds = []
        localStorage.removeItem('selectedBridge')
        this.clearMultiBridgeSelection()
        
        console.log('【Layout】清空桥梁选择')
        
        // 触发清空事件
        this.$root.$emit('bridge-changed', null)
        const eventData = {
          selectedBridges: [],
          selectedBridgeIds: [],
          primaryBridge: null
        };
        console.log('【Layout】触发bridges-selection-changed事件(清空):', eventData);
        this.$root.$emit('bridges-selection-changed', eventData)
      }
    },
    
    // 处理桥梁选择变更（保留原有方法以支持其他组件）
    async handleBridgeChange(bridgeId) {
      if (bridgeId) {
        // 设置选择的桥梁ID
        this.selectedBridgeId = bridgeId;
        
        // 从选项中查找桥梁对象 (现在应该已经包含了完整的位置信息)
        const bridge = this.bridgeOptions.find(b => b.id === bridgeId);
        if (bridge) {
          // 确认桥梁对象是否包含位置信息
          if (bridge.latitude && bridge.longitude) {
            console.log(`桥梁 ${bridge.name} 包含位置信息: [${bridge.latitude}, ${bridge.longitude}]`);
          } else {
            console.warn(`桥梁 ${bridge.name} 不包含位置信息`);
          }
          
          // 更新当前选中的桥梁对象
          this.selectedBridge = bridge;
          
          // 先保存到localStorage
          localStorage.setItem('selectedBridge', JSON.stringify(bridge));
          
          // 异步更新视频监控URL
          try {
            console.log('正在为新选择的桥梁更新视频监控URL...');
            // 清除之前的视频监控URL缓存
            const cacheData = localStorage.getItem(VideoUrlManager.STORAGE_KEY);
            if (cacheData) {
              const cache = JSON.parse(cacheData);
              if (cache[bridgeId]) {
                // 移除当前桥梁的缓存，强制重新获取最新URL
                delete cache[bridgeId];
                localStorage.setItem(VideoUrlManager.STORAGE_KEY, JSON.stringify(cache));
              }
            }
            
            // 主动获取新的视频监控URL
            const videoUrl = await VideoUrlManager.getVideoUrl();
            console.log('已更新视频监控URL:', videoUrl);
            
            // 向全局事件总线发送菜单刷新事件
            this.$root.$emit('refresh-menu', { bridgeId, videoUrl });
          } catch (error) {
            console.error('更新视频监控URL失败:', error);
          }
          
          // 然后触发事件通知其他组件
          this.$root.$emit('bridge-changed', bridge);
          
          console.log(`选择桥梁: ${bridge.name}, ID: ${bridgeId}`);
        } else {
          console.error('未找到与ID匹配的桥梁:', bridgeId);
        }
      } else {
        console.warn('桥梁选择为空');
      }
    },

    /**
     * 写入桥梁ID到signalr身份并触发身份刷新
     * @param {Object} bridge - 桥梁对象
     */
    async updateSignalRIdentityWithBridge(bridge) {
      if (!bridge || !bridge.id) return;
      try {
        // 将当前桥梁ID写入本地身份存储
        const identityStr = localStorage.getItem('signalrClientInfo');
        if (identityStr) {
          try {
            const identity = JSON.parse(identityStr);
            identity.metaData = identity.metaData || {};
            identity.metaData.bridgeId = bridge.id;
            identity.clientId = bridge.id;
            localStorage.setItem('signalrClientInfo', JSON.stringify(identity));
          } catch (e) {
            console.warn('更新signalrClientInfo桥梁ID失败，重置存储', e);
            localStorage.setItem('signalrClientInfo', JSON.stringify({
              clientId: bridge.id,
              userId: '',
              deviceId: '',
              customType: 'Web',
              metaData: { bridgeId: bridge.id },
              savedAt: new Date().toISOString()
            }));
          }
        } else {
          localStorage.setItem('signalrClientInfo', JSON.stringify({
            clientId: bridge.id,
            userId: '',
            deviceId: '',
            customType: 'Web',
            metaData: { bridgeId: bridge.id },
            savedAt: new Date().toISOString()
          }));
        }

        // 如果未连接，先尝试连接（携带当前桥梁ID作为clientId）
        if (this.$signalR && !this.$signalR.isConnected) {
          const serverUrl = this.$appConfig?.signalR?.serverUrl;
          if (serverUrl) {
            try {
              await this.$signalR.connect(serverUrl, { clientId: bridge.id });
              console.log('SignalR未连接，已尝试连接并携带桥梁ID:', bridge.id);
            } catch (connectErr) {
              console.warn('SignalR连接失败，稍后重试身份刷新', connectErr);
            }
          }
        }

        if (this.$signalR && typeof this.$signalR.refreshIdentity === 'function') {
          await this.$signalR.refreshIdentity();
          console.log('已触发SignalR身份重注册(bridge)', bridge.id);
        } else {
          console.warn('SignalR身份刷新不可用，跳过重注册');
        }
      } catch (error) {
        console.error('更新SignalR桥梁身份失败:', error);
        this.$message.error('桥梁通信身份刷新失败，请稍后重试');
      }
    },
  },
  mounted() {
    // 初始化监听
    this.$nextTick(() => {
      // 监听窗口大小变化
      window.addEventListener('resize', () => {
        if (this.activeMenu) {
          // 移除对不存在方法的调用
          // this.updateSubmenuPosition(this.activeMenu);
        }
      });
      
      // 监听滚动事件
      const sidebarMenu = document.getElementById('sidebar-menu');
      if (sidebarMenu) {
        sidebarMenu.addEventListener('scroll', () => {
          if (this.activeMenu) {
            // 移除对不存在方法的调用
            // this.updateSubmenuPosition(this.activeMenu);
          }
        });
      }
      
      // 监听是否存在经纬度面板，如果存在则需要调整子菜单位置
      this.checkForCoordinatesPanel();
      
      // 每当DOM可能发生变化时重新检查
      const observer = new MutationObserver(() => {
        if (this.activeMenu) {
          this.checkForCoordinatesPanel();
          // 移除对不存在方法的调用
          // this.updateSubmenuPosition(this.activeMenu);
        }
      });
      
      // 监视body元素及其子元素的变化
      observer.observe(document.body, { 
        childList: true,
        subtree: true 
      });
    });
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', () => {});
    const sidebarMenu = document.getElementById('sidebar-menu');
    if (sidebarMenu) {
      sidebarMenu.removeEventListener('scroll', () => {});
    }
  }
}